import { withFormik } from 'formik'

import CoachingStudiesChunk                      from './chunks/CoachingStudiesChunk'
import { genValueMapper, proxyFormikSubmission } from './form-utils'
import { asFormStep }                            from './wrappers'

const formik = {
  handleSubmit:     proxyFormikSubmission,
  mapPropsToValues: genValueMapper({ coachingStudies: [] }),
}

export default withFormik(formik)(asFormStep(CoachingStudiesChunk))



// WEBPACK FOOTER //
// ./src/components/forms/CoachingStudiesFormStep.tsx